import axios from 'axios'
import Utils from '../common/utils'

// 创建 axios 实例
// let baseUrl = process.env.NODE_ENV === 'development' ? 'https://a.cfbond.com/' : 'https://a.cfbond.com/'
let baseUrl = process.env.NODE_ENV === 'development' ? 'https://goldeye.cfbond.com/' : 'https://a.cfbond.com/'
// eslint-disable-next-line
console.log(process.env)
window.baseUrl = baseUrl
const channelCode = '9203'
// let baseUrl = process.env.NODE_ENV === 'development' ? '' : 'https://mall.uyiqu.com'
let http = axios.create({
  timeout: 60000,
  baseURL: baseUrl
  // withCredentials: true
})

let headerData = {
  SOURCE: Utils.getQueryString('source'),
  DEVICEID: Utils.getQueryString('deviceId'),
  TOKEN: Utils.getQueryString('token'),
  SIGNRESULT: Utils.getQueryString('signresult') || ''
}

// 添加请求拦截器
http.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'development') {
    config.url = '' + config.url
  }
  config.headers = {
    ...config.headers,
    TIMESTAMP: Date.now().toString().slice(0, 10),
    SOURCE:headerData.SOURCE,
    'DEVICE-ID':headerData.DEVICEID,
    TOKEN: headerData.TOKEN,
    'SIGN-RESULT': headerData.SIGNRESULT
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

export default{
  http,
  baseUrl,
  channelCode
}
